
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.39315 1.98118C7.2888 0.728943 9.56188 0 12 0C14.4381 0 16.7112 0.728943 18.6068 1.98118L16.7171 4.84193C15.3648 3.94865 13.7458 3.42857 12 3.42857C10.2542 3.42857 8.63517 3.94865 7.28292 4.84193L5.39315 1.98118ZM0 12C0 9.56188 0.728943 7.2888 1.98118 5.39315L4.84193 7.28292C3.94865 8.63517 3.42857 10.2542 3.42857 12C3.42857 13.7458 3.94865 15.3648 4.84193 16.7171L1.98118 18.6068C0.728943 16.7112 0 14.4381 0 12ZM22.0188 5.39315C23.2711 7.2888 24 9.56188 24 12C24 14.4381 23.2711 16.7112 22.0188 18.6068L19.1581 16.7171C20.0514 15.3648 20.5714 13.7458 20.5714 12C20.5714 10.2542 20.0514 8.63517 19.1581 7.28292L22.0188 5.39315ZM12 24C9.56188 24 7.2888 23.2711 5.39315 22.0188L7.28292 19.1581C8.63517 20.0514 10.2542 20.5714 12 20.5714C13.7458 20.5714 15.3648 20.0514 16.7171 19.1581L18.6068 22.0188C16.7112 23.2711 14.4381 24 12 24Z","fill":"#272727"}})])
          )
        }
      }
    